function HeroVideo() {
  document.addEventListener("DOMContentLoaded", () => {
    const videoBackground = document.getElementById('videoBackground');
    if(typeof(videoBackground) != 'undefined' && videoBackground != null) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if(!reducedMotion || reducedMotion.matches) {
        videoBackground.classList.add('u-hidden');
      }
      
      const lightboxTrigger = document.getElementById('playVideo');
      const lightboxVideo = document.getElementById('lightboxVideo');

      lightboxTrigger.addEventListener('click', e => {
        videoBackground.removeAttribute('autoplay');
        lightboxVideo.classList.remove('u-hidden');
      });
  
      lightboxVideo.addEventListener('click', (e) => {
        if (!e.target.classList.contains('c-lightbox__video')) {
          videoBackground.setAttribute('autoplay','');
          lightboxVideo.classList.add('u-hidden');
        }
      });
      window.addEventListener('keydown', function(e) {
        if (e.key == "Escape") {
          videoBackground.setAttribute('autoplay','');
          lightboxVideo.classList.add('u-hidden');
        }
      });
    }
  });
}

export default HeroVideo;